import {
  toggleFullScreen,
  isFullScreenAvailable
} from "@/services/fullScreenService"
import { Ref } from "vue"
export default function setup(playerContainer: Ref<HTMLElement | undefined>) {
  function togglefullscreen() {
    if (playerContainer.value && isFullScreenAvailable())
      toggleFullScreen(playerContainer.value)
  }

  return { togglefullscreen }
}
